// Match the acceptance record to the renewal's product, not another product's consent.
export function termsAcceptance(row) {
    const type = (row.caseType || '').trim().toLowerCase();
    const prefix = type === 'cobra' ? 'cobra' : type === 'employee benefits' || type === 'eb' ? 'eb' : null;
    if (!prefix) return { accepted: 'N/A', acceptedBy: '—' };
    const value = row[`${prefix}ApiTermsAccepted`];
    const accepted = value === true || value === 'true';
    return {
      accepted: accepted ? 'Yes' : value === false || value === 'false' ? 'No' : '—',
      acceptedBy: accepted ? row[`${prefix}ApiTermsAcceptedBy`] || '—' : '—',
    };
  }
  